import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import firebase from 'firebase/app';
import 'firebase/firestore';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import ReactGA from 'react-ga';

import Routes from './Routes';
import reducers from './reducers';
import rootSaga from './sagas/rootSaga';

let debug = true;
// if (process.env.NODE_ENV === 'production') debug = false;
ReactGA.initialize('UA-121213369-1', { debug });

const history = createHistory();
const historyMiddleware = routerMiddleware(history);

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  reducers,
  applyMiddleware(sagaMiddleware, historyMiddleware)
);
sagaMiddleware.run(rootSaga, store.dispatch);

// const action = type => store.dispatch({ type });

class App extends React.Component {
  componentWillMount() {
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyBV4JQXdyDU_gXwuUWVjcQgTph_O4N6o2o',
        authDomain: 'seniorpromadm.firebaseapp.com',
        databaseURL: 'https://seniorpromadm.firebaseio.com',
        projectId: 'seniorpromadm',
        storageBucket: '',
        messagingSenderId: '690785956971'
      });

      const firestore = firebase.firestore();
      firestore.settings({ timestampsInSnapshots: true });
      firestore.enablePersistence();
    }
  }

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js